import { render, staticRenderFns } from "./cooperationMall.vue?vue&type=template&id=11b2a1a5&scoped=true"
import script from "./cooperationMall.vue?vue&type=script&lang=js"
export * from "./cooperationMall.vue?vue&type=script&lang=js"
import style0 from "./cooperationMall.vue?vue&type=style&index=0&id=11b2a1a5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2a1a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b2a1a5')) {
      api.createRecord('11b2a1a5', component.options)
    } else {
      api.reload('11b2a1a5', component.options)
    }
    module.hot.accept("./cooperationMall.vue?vue&type=template&id=11b2a1a5&scoped=true", function () {
      api.rerender('11b2a1a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/cooperationMall.vue"
export default component.exports